export const ComplexityLevelOptions = [
    {
        label: '9-10 Grade',
        value: '9-10_GRADE',
    },
    {
        label: '11-12 Grade',
        value: '11-12_GRADE',
    },
    {
        label: 'Lower Undergraduate',
        value: 'LOWER_UNDERGRADUATE',
    },
    {
        label: 'Upper Undergraduate',
        value: 'UPPER_UNDERGRADUATE',
    },
    {
        label: 'Graduate',
        value: 'GRADUATE',
    },
]

export const InAccurateReasonOptions = [
    {
        label: 'Correct response, incorrect answer',
        value: 'Correct response, incorrect answer',
    },
    {
        label: 'Incorrect response, correct answer',
        value: 'Incorrect response, correct answer',
    },
    {
        label: 'Both incorrect',
        value: 'Both incorrect',
    },
]

export const LMFInAccurateReasonOptions = [
    {
        label: 'Correct Reasoning Trace, Incorrect Final Answer',
        value: 'Correct Reasoning Trace, Incorrect Final Answer',
    },
    {
        label: 'Incorrect Reasoning Trace, Correct Final Answer',
        value: 'Incorrect Reasoning Trace, Correct Final Answer',
    },
    {
        label: 'Incorrect Reasoning Trace, Incorrect Final Answer',
        value: 'Incorrect Reasoning Trace, Incorrect Final Answer',
    },
]

export const ModelFeedbackResultCodeToLabel: { [key: number]: string } = {
    3: 'Model Response Critic',
    6: 'Reasoning Trace to Step-by-Step (SBS) Format',
    9: 'Reasoning Trace to Final Answer Extraction',
}
